import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setReload, setModalOpen, setSelectedItem } from 'store/ResponseTemplate/actions';
import { Button, Typography, Box, Grid } from '@mui/material';
import { hardDeleteResponseTemplate } from 'utils/apolloQueries';
import axios from 'utils/axios';
import AnnouncementImage from 'assets/images/dashboard/announcement.svg';
import { SET_LOADING, SET_TOAST_OBJECT } from 'store/actions';
const accessToken = localStorage.getItem('diologAuthToken');
function PermanentDeleteTemplate() {
    const dispatch = useDispatch();
    const { companyData } = useSelector((params) => params.customization);
    const { selectedItem, reload } = useSelector((params) => params.response);
    const handleClose = () => dispatch({ type: setModalOpen, modalOpen: false });
    const handleDelete = () => {
        dispatch({ type: SET_LOADING, loading: true });
        dispatch({ type: SET_TOAST_OBJECT, toastObject: { status: false } });
        let variables = {
            responseTemplateDeleteInput: {
                responseTemplateId: selectedItem._id,
                companyId: companyData._id
            }
        };
        const submitData = { query: hardDeleteResponseTemplate, variables: variables };
        axios({
            method: 'POST',
            data: submitData,
            headers: {
                Authorization: accessToken
            }
        })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data) {
                        if (response.data.data) {
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: {
                                    status: true,
                                    variant: 'success',
                                    message: 'Response template permanently successfully deleted'
                                }
                            });
                            dispatch({ type: SET_LOADING, loading: false });
                            dispatch({ type: setReload, reload: !reload });
                            dispatch({ type: setModalOpen, modalOpen: false });
                        } else {
                            dispatch({
                                type: SET_TOAST_OBJECT,
                                toastObject: {
                                    status: true,
                                    variant: 'error',
                                    message: 'Something went wrong while trying to delete the announcement. Please try again later'
                                }
                            });
                            dispatch({ type: SET_LOADING, loading: false });
                            console.log(response);
                        }
                    }
                } else {
                    dispatch({
                        type: SET_TOAST_OBJECT,
                        toastObject: {
                            status: true,
                            variant: 'error',
                            message: 'Something went wrong while trying to delete the announcement. Please try again later'
                        }
                    });
                    dispatch({ type: SET_LOADING, loading: false });
                    console.log(response);
                }
            })
            .catch(function (response) {
                dispatch({
                    type: SET_TOAST_OBJECT,
                    toastObject: {
                        status: true,
                        variant: 'error',
                        message: 'Something went wrong while trying to delete the announcement. Please try again later'
                    }
                });
                dispatch({ type: SET_LOADING, loading: false });
                console.log(response);
            });
    };
    return (
        <>
            <Box className="modal-hero">
                <img src={AnnouncementImage} alt="announcement" />
            </Box>
            <Box className="modal-body">
                <Typography variant="h2" component="h2">
                    Are you sure you want to delete this?
                </Typography>
                <Typography variant="p" component="p">
                    This item will be deleted permanently. You can’t undo this action.
                </Typography>
            </Box>
            <Box className="modal-footer pt-0">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Button variant="outlined" className="alternate-reversed w-full" onClick={handleClose}>
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" className="alternate w-full" onClick={handleDelete}>
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default PermanentDeleteTemplate;
